import { Box, Button, Grid, Typography } from "@mui/material"

import useAuth from "../../../context/auth"
import { Link } from "react-router-dom"
import { RiFileExcel2Line } from "react-icons/ri"

const ufs = [
    "AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO",
    "MA", "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI",
    "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO"
]

export const PartnerMailing = () => {
    const { isMobile } = useAuth()
    const linkBase = "https://s3.us-east-1.amazonaws.com/static.gyroo.com.br/app/mailing/"

    return (
        <Box
            sx={{
                maxWidth: "150rem",
                width: "100%",
                margin: "0 auto",
                ...(!isMobile && {
                    padding: "0 2rem",
                    width: "auto",
                }),
                display: "flex",
                flexDirection: "column",
                gap: "2rem"
            }}
        >
            <Typography fontSize={"2rem"} fontWeight={600} mb={"2rem"}>Contatos Mailing</Typography>

            <Typography variant="h3" textAlign={"center"}>Lista de mailing com 2 milhões de empresas de todos os estados (UF)</Typography>

            <Typography textAlign={"center"} fontStyle={"italic"}>
                Os dados fornecidos são essenciais para prospecção por e-mail, WhatsApp, SMS, URA e ligações telefônicas, garantindo uma abordagem eficiente.
            </Typography>

            <Typography textAlign={"center"} fontStyle={"italic"} color="primary">
                Para baixar a lista do estado (UF) desejado, clique no arquivo correspondente abaixo e faça o download em formato Excel.
            </Typography>

            <Typography variant="h3" textAlign={"center"} m={"2rem 0rem 4rem"}>Desejamos ótimas vendas!</Typography>

            <Grid
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: isMobile ? "2rem 2rem" : "5rem 2rem",
                    justifyContent: "center",
                }}
            >
                {ufs.map((uf) => (
                    <Link key={uf} to={`${linkBase}${uf}.xlsx`} target="_blank" download>
                        <Button variant="contained" sx={{ minWidth: isMobile ? "90vw" : "30rem", }} startIcon={<RiFileExcel2Line />}>
                            <Typography fontSize={"1.4rem"}>
                                Baixar lista UF: <strong>{uf}</strong>
                            </Typography>
                        </Button>
                    </Link>
                ))}
            </Grid>

        </Box>
    )
}